export function tokenGenerator(length=10) {
  let chunks = []
  for(let i=0; i<length*4; i+=1) {
    chunks.push(String.fromCharCode(Math.random()*127))
  }
  return btoa(chunks.join(',')).slice(0, length)
}

export function dropRendererMetaData(collectedData) {
  return Object.fromEntries(
    Object.entries(collectedData).filter(([key, value]) => !key.startsWith("FORMHERO"))
  )
}